<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-danger" style="text-transform:uppercase;">{{ title }} </h4>
                <button type="button" class="close" aria-label="Close" @click="onClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" id="dialog_content">
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-dark pull-left" @click="onClose()">&nbsp;{{
                    $t('buttons.close') }}</button>
                <button type="button" class="btn btn-outline-danger pull-right" @click="onSubmit()">&nbsp;{{
                    confirmLabelButton }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
export default {
    name: "TheConfirmDialog",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        modalContent: String,
    },
    methods: {
    },
    watch: {
        modalContent(newContent) {
            let contentDiv = document.getElementById('dialog_content');
            contentDiv.innerHTML = newContent || '';
        }
    },
    async mounted() {
        if (this.modalContent) {
            let contentDiv = document.getElementById('dialog_content');
            contentDiv.innerHTML = this.modalContent;
        }
    },
}
</script>
<style></style>